import { defineComponent as _defineComponent } from 'vue'
import BaseSelect from "@/components-UI/BaseSelect.vue";
import OfferParamsForm from "@/components/offers/offer/products/OfferParamsForm.vue";
import Loader from "@/components/base/Loader.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import { computed, onMounted, ref } from "vue";
import { showServerError } from "@/utils";
import { getOfferParams } from "@/api/offers";
import { IOfferProduct } from "@/api/types/offers";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";

interface Props {
    offer: OfferSingle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferProducts',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle;
}



const products = ref<IOfferProduct[]>([]);
const isShowForm = ref(false);
const productForm = ref<OfferParamsForm[]>(null);

const tooltipText = 'Вначале необходимо заполнить данные по "URL оффера по-умолчанию". После необходимо заполнить данные по остальным URL, которые будут отличаться от данных "URL оффера по-умолчанию". Остальные данные заполнять не нужно, они подтянутся из данных "URL оффера по-умолчанию"';

onMounted(() => {
    getParams();
});

const getParams = async () => {
    isShowForm.value = true;
    try {
        const { data } = await getOfferParams(props.offer.legacy_id as number);
        products.value = data;
    } catch (err) {
        showServerError(err, 'Параметры оффера не загружены');
    } finally {
        isShowForm.value = false;
    }
};

const availableProducts = computed(() => {
    return Object.keys(props.offer.offerParamsForms).map(i => Number(i));
});

const getProductData = (productId: number) => {
    const allProductsByUrl = products.value.filter(i => i.url.legacy_id === selectedUrl.value);
    return allProductsByUrl.find(i => i.product.id === productId);
};

const selectedUrl = ref(0);

const getUrlItems = computed(() => {
    const defaultItem = { value: 0, text: 'URL по умолчанию' };
    const items = props.offer.additional_urls?.map(i => ({ text: i.name, value: i.legacy_id })) || [];
    return [defaultItem, ...items];
});

const selectUrl = (value: number) => {
    selectedUrl.value = value;
};


return { __sfc: true,props, products, isShowForm, productForm, tooltipText, getParams, availableProducts, getProductData, selectedUrl, getUrlItems, selectUrl, BaseSelect, OfferParamsForm, Loader, BaseQuestionMarkTooltip }
}

})